module.exports = __webpack_public_path__ + "static/media/nd2.31834ab7.webp";